import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/app/game/page.tsx");
